import {Container} from "aurelia-framework";
import {Args, Impl, ImplOrAny, PrimitiveOrDependencyCtor} from "aurelia-dependency-injection";

export function instance<TBase, TImpl extends Impl<TBase> = Impl<TBase>, TArgs extends Args<TBase> = Args<TBase>>(key: PrimitiveOrDependencyCtor<TBase, TImpl, TArgs>): ImplOrAny<TImpl> {
  return Container.instance.get(key);
}
